import type { RadioGroupChangeEventDetails } from '@base-ui/react/radio-group';
import { Trans } from '@lingui/react/macro';

import type { UserRoleType } from '@/api/user';
import { RadioGroup, type RadioGroupProps } from '@/components/Form';
import { FieldSet } from '@/components/Form/fields';
import PermissionItem from '@/features/PermissionGroup/PermissionItem';

type Props = Omit<RadioGroupProps, 'onValueChange' | 'value'> & {
  isEditing: boolean;
  isSaving: boolean;
  value: UserRoleType;
  onValueChange: (value: UserRoleType, eventDetails: RadioGroupChangeEventDetails) => void;
};

const PermissionGroup = ({ isEditing, isSaving, value, ...rest }: Props) => {
  return (
    <FieldSet>
      <RadioGroup className="gap-6" value={value} {...rest}>
        <PermissionItem
          type="user"
          isEditing={isEditing}
          disabled={isSaving}
          role={value}
          title={<Trans>User Permission</Trans>}
          description={
            <Trans>
              Users have permissions to view all data, save filters and edit spend information
            </Trans>
          }
        />
        <PermissionItem
          type="admin"
          isEditing={isEditing}
          disabled={isSaving}
          role={value}
          title={<Trans>Admin Permission</Trans>}
          description={
            <Trans>
              Admins have all user permissions and the ability to map vendors, add users, manage
              users and edit TAM
            </Trans>
          }
        />
      </RadioGroup>
    </FieldSet>
  );
};

export default PermissionGroup;
